import React from 'react';
import PropTypes from 'prop-types';

const PaymentGatewayCredentialsActions = ({ data, history }) => {
    const handleActionClick = mode => {
        history.push(
            `/payment-gateway-credentials/${mode}/credentials/${data.original.pgMid}`
        );
    };
    return (
        <div className="userAction  multiItem">
            <button
                className="edit"
                onClick={() => handleActionClick('edit')}
            />
            <button
                className="view"
                onClick={() => handleActionClick('view')}
            />
        </div>
    );
};
PaymentGatewayCredentialsActions.propTypes = {
    data: PropTypes.object,
    history: PropTypes.object,
};

export default PaymentGatewayCredentialsActions;
